import { supabase } from '../supabaseClient';

// W0-6: jedno źródło estymaty ceny (czyta pricing_config). Serwer (charge_order) liczy to samo autorytatywnie.
let _cache = null;
export async function fetchPricing() {
  if (_cache) return _cache;
  const { data } = await supabase
    .from('pricing_config')
    .select('action, marketplace, credits_cost, active')
    .eq('active', true);
  const map = { offer_text: 1, aplus_panel: 2 };
  (data || []).forEach((r) => { if (r.marketplace == null) map[r.action] = Number(r.credits_cost); });
  _cache = map;
  return map;
}
export function estimateCredits(pricing, { offers = 0, aplusPanels = 0 } = {}) {
  const co = (pricing && pricing.offer_text) || 1;
  const cp = (pricing && pricing.aplus_panel) || 2;
  return Math.ceil(offers * co + aplusPanels * cp);
}
